import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const EmailSyncWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: theme.spacing[12],
  overflow: 'hidden',
  borderRadius: 4,
  backgroundColor: theme.colors.midnight,
  padding: theme.spacing[16],
}));

export const EmailSyncBannerGraphic = styled.img({
  width: 80,
  height: 96,
  objectFit: 'contain',
  flexShrink: 0,
  alignSelf: 'center',
});

export const ContentWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[12],
  flex: 1,
}));

export const BannerTitle = styled(Typography).attrs({ variant: TextStyles['Heading 3'] })(({ theme }) => ({
  color: theme.colors.highEmphasisWhite,
}));

export const GmailStyleButton = styled.button(({ theme }) => ({
  padding: 0,
  maxWidth: 158,
  height: theme.spacing[36],
  background: theme.colors.surface02,
  borderRadius: theme.spacing[4],
  border: 'none',
  cursor: 'pointer',
  textTransform: 'uppercase',
  color: theme.colors.darkBlue,

  '&:hover': {
    opacity: 0.9,
  },

  '&:disabled': {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
}));
